import queryString from 'query-string';
import { token } from '../auth/indentityAuth';

const apiUrl = process.env.REACT_APP_API_URL;

function AuthorizedHeaders() {
  const headers = new Headers();
  headers.append('Authorization', `${token.token_type} ${token.access_token}`);
  headers.append('Ocp-Apim-Subscription-Key', process.env.REACT_APP_SUBSCRIPTION_KEY);
  return headers;
}

function Parameters(query) {
  let parameters = '';
  if (query) {
    parameters = queryString.stringify(query);
  }
  return parameters && '?' + parameters;
}

export function Get(resource, query) {
  return new Request(apiUrl + resource + Parameters(query), {
    method: 'GET',
    headers: AuthorizedHeaders(),
  });
}

export function Post(resource, body) {
  return new Request(apiUrl + resource, {
    method: 'POST',
    headers: AuthorizedHeaders(),
    body,
  });
}

export async function Perform(request, readBody) {
  const response = await fetch(request);
  if (response.ok) {
    if (readBody) {
      return response.json();
    }
    // resolve to undefined here (response is ok + readBody is false)
  } else {
    let err;
    try {
      err = await response.json();
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }
}
